import type { AxiosResponse } from "axios";

import { getData, postData, putData } from "@/apis/apiInstance";

import type {
  AddOpenItemCommentPayload,
  GetAdminOpenItemsListingPayload,
  GetAllOpenItemCommentsPayload,
  GetClientOpenItemsListingPayload,
  GetSingleOpenItemPayload,
  SendOpenItemEmailPayload,
  UploadOpenItemsPayload,
} from "@/commonTypes/openItemsTypes";
import type { AddOpenItemPayload } from "@/commonTypes/openItemsTypes";

import { getCSRFToken } from "@/utils/commonFunctions";

/* ADMIN SIDE APIs */
export async function getAdminOpenItemsListApi(
  data: GetAdminOpenItemsListingPayload
): Promise<AxiosResponse> {
  const { token, search_term, limit, offset } = data;
  const findalData = {
    limit,
    offset,
    // sort_by: 'job_type'
  };
  const dataWithSearch = {
    search_term,
    limit,
    offset,
    // sort_by: 'job_type'
  };

  return await getData(`open-item/list`, {
    params: search_term && search_term !== "" ? dataWithSearch : findalData,
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function addAdminOpenItemsApi(
  data: AddOpenItemPayload
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    job_id,
    job_type,
    job_end_date,
    summary,
    item_data,
  } = data;

  const finalData = {
    client_code,
    job_id,
    job_type,
    job_end_date,
    summary,
    item_data,
  };
  return await postData(`open-item`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateAdminOpenItemsApi(
  payload: any
): Promise<AxiosResponse> {
  const { job_id, token, summary, item_data } = payload;

  const finalData = {
    summary,
    item_data,
  };
  return await putData(`open-item/${job_id}`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateStatusAdminOpenItemsApi(
  payload: any
): Promise<AxiosResponse> {
  const { token, jobId, item_data } = payload;

  return await putData(
    `open-item/items-approval/${jobId}`,
    {
      item_data: item_data,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function sendOpenItemEmailApi(
  data: SendOpenItemEmailPayload
): Promise<AxiosResponse> {
  const { token, open_item_id } = data;

  return await getData(`open-item-send-email`, {
    params: {
      open_item_id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

/* CLIENT SIDE APIs */
export async function getClientOpenItemsListApi(
  data: GetClientOpenItemsListingPayload
): Promise<AxiosResponse> {
  const { token, limit, offset, client_code, search_term } = data;

  return await getData(`open-item-client/list`, {
    params: {
      client_code,
      search_term,
      limit,
      offset,
      // sort_by: 'job_type'
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function uploadClientOpenItemsApi(
  data: UploadOpenItemsPayload
): Promise<AxiosResponse> {
  const { item_data, openItemId, token } = data;

  return await postData(
    `open-item-client/file-upload/${openItemId}`,
    { item_data },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

/* Others */
export async function getAdminOpenItemsSingleApi(
  data: GetSingleOpenItemPayload
): Promise<AxiosResponse> {
  return await getData(`open-item/${data.jobId}`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": data.token,
    },
  });
}

export async function getAllOpenItemCommentsApi(
  data: GetAllOpenItemCommentsPayload
): Promise<AxiosResponse> {
  const { token, item_id, open_item_id } = data;

  return await getData(
    `open-item-client/${open_item_id}/comments/list/${item_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}

export async function addOpenItemCommentApi(
  data: AddOpenItemCommentPayload
): Promise<AxiosResponse> {
  const { token, item_id, comment, open_item_id } = data;
  let finalData = {
    item_id,
    comment,
  };

  return await postData(`open-item-client/${open_item_id}/comment`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
